/**
 * Map
 * 
 * @Author: Focci
 * @Date: 2023-08-07 14:37:34
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 14:37:34
 */

import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useApp from '@hook/useApp'
// import LocationMap from '../location/LocationMap'

const LocationMap = dynamic(() => import('../location/LocationMap'), { ssr: false })

export default function Map({
  house = {}
}) {
  const { isMobile } = useApp()

  const mapboxDefaultValue = {
    longitude: house.lng,
    latitude: house.lat,
    // scrollZoom: false,
    zoom: 18
  }
  
  return (
    <div className="flex flex-col border bg-cf0 absolute inset-0">
      <LocationMap
        type={house.type}
        houseId={house.houseId}
        propertyId={house.propertyId}
        defaultValue={mapboxDefaultValue}
        fitPadding={isMobile ? 100 : 200}
        house={house}
      />
    </div>
  )
}

Map.propTypes = {
  house: PropTypes.object,
}

export function MaxWidthMap(props) {
  return (
    <div className="h-full max-w-[1680px] mx-auto relative">
      <Map {...props} />
    </div>
  )
}
